import { themeCandor } from "@shetharp/gatsby-theme-candor";

export const themeSite = {
  ...themeCandor,

  // ==================================================
  // This site's theme overrides
  // https://theme-ui.com/packages/gatsby-theme-ui-blog/#theming
  // ==================================================
  // TODO
};
export default themeSite;
